<template>
	<b-button :variant="variant" v-on:click="action()"><span>{{ text }}</span><svg-icon :name="icon"/></b-button>
</template>

<script>
	export default {
		props: {
			variant: {
				type: String,
				default: 'default'
			},
			text: {
				type: String,
				default: ''
			},
			icon: {
				type: String,
				default: 'search'
			},
			action: {
				type: Function,
				default(){}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// MyButton.vue?c7615488